import { EVIDENCE, FEATURED_EVIDENCE } from "@/data/evidence";

export function useEvidence(featured = false) {
  return { records: featured ? FEATURED_EVIDENCE : EVIDENCE, loading: false };
}
